import { __read, __spread, __values } from "tslib";
import { logger, generateBase36Id } from '@amplitude/utils';
var DefaultIdentity = /** @class */ (function () {
    function DefaultIdentity() {
        this._deviceId = null;
        this._userId = null;
        this._identityListeners = [];
    }
    /**
     * Initializes a device ID for this instance (or takes the one passed in).
     *
     * Trying to initialize twice is a no-op and will do nothing - device IDs should not change
     * in an instance. if you want to reset a device ID, use the identity manager's resetInstance
     *
     * @param   {string} deviceId An optional parameter to set the device ID to use.
     * @returns {string}          The device ID that will be used for this instance going forward.
     */
    DefaultIdentity.prototype.initializeDeviceId = function (deviceId) {
        if (deviceId === void 0) { deviceId = ''; }
        // Only try to set the device ID if the deviceID is not already set.
        if (this._deviceId !== null) {
            logger.warn('Cannot set device ID twice for same identity. Skipping operation.');
            return this._deviceId;
        }
        var deviceIdToUse = '';
        if (typeof deviceId === 'string' && deviceId.length > 0) {
            deviceIdToUse = deviceId;
        }
        else if (typeof deviceId === 'number') {
            // type safety - in case a number gets passed in.
            deviceIdToUse = String(deviceId);
        }
        else {
            deviceIdToUse = DefaultIdentity.generateDefaultId();
        }
        this._deviceId = deviceIdToUse;
        this._alertIdentityListeners();
        return this._deviceId;
    };
    DefaultIdentity.prototype.getDeviceId = function () {
        if (this._deviceId == null) {
            logger.warn('Did not detect device ID; generating one for this instance.');
            return this.initializeDeviceId();
        }
        else {
            return this._deviceId;
        }
    };
    DefaultIdentity.prototype.setUserId = function (userId) {
        if (userId === void 0) { userId = null; }
        if (typeof userId === 'string') {
            this._userId = userId;
        }
        else if (typeof userId === 'number') {
            // type safety - in case a number gets passed in
            this._userId = String(userId);
        }
        else if (userId == null) {
            this._userId = null;
        }
        else {
            logger.warn('User ID did not have correct type. Skipping operation.');
            return;
        }
        this._alertIdentityListeners();
    };
    DefaultIdentity.prototype.getUserId = function () {
        return this._userId;
    };
    DefaultIdentity.prototype._alertIdentityListeners = function () {
        var e_1, _a;
        if (this._deviceId == null) {
            // If there was no device ID, create one and let
            // initializeDeviceID re-alert this function
            this.initializeDeviceId();
        }
        else {
            try {
                for (var _b = __values(this._identityListeners), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var listener = _c.value;
                    listener(this._deviceId, this._userId);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
    };
    DefaultIdentity.prototype.addIdentityListener = function () {
        var _a;
        var listeners = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            listeners[_i] = arguments[_i];
        }
        (_a = this._identityListeners).push.apply(_a, __spread(listeners));
    };
    DefaultIdentity.prototype.getIdentityListeners = function () {
        // Return a copy of the listeners
        return Array.from(this._identityListeners);
    };
    DefaultIdentity.generateDefaultId = function () {
        return generateBase36Id();
    };
    return DefaultIdentity;
}());
export { DefaultIdentity };
//# sourceMappingURL=identity.js.map